class Header {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function() {
      $(window).on("scroll", function () {
        const sliderHeight = $(".s-mv").height();
        if (sliderHeight - 30 < $(this).scrollTop()) {
          $("body").removeClass("top");
        } else {
          $("body").addClass("top");
        }
      });
  });
  }
}
